import {Component, Input, OnDestroy, OnInit} from '@angular/core';

import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {EditModalCustomPriceTableService} from '../../../services/edit-modal-custom-price-table.service';
import {Subscription} from 'rxjs';
import {ModalVisibilityService} from '../../../services/modal-visibility.service';
import {MyPriceApprovalModeEnum} from '../../../enums/my-price-approval-mode.enum';
import {MyContainersTableIdEnum} from '../../../enums/my-containers-table-id.enum';

@Component({
    selector: 'app-project-product-summary-viewer',
    templateUrl: './product-summary-viewer.component.html',
    styleUrls: ['./product-summary-viewer.component.scss']
})
export class ProjectProductSummaryViewerComponent extends EditModalSectionBaseComponent implements OnInit, OnDestroy {

    @Input() usePriceApprovalMode = MyPriceApprovalModeEnum.DISABLED;
    private modalVisibilitySub: Subscription;
    private rPriceInfoModalDialogRef: any;

    public MyContainersTableIdEnum = MyContainersTableIdEnum;

    constructor(
        public editModalService: EditModalService,
        public editModalCustomPriceTableService: EditModalCustomPriceTableService,
        public modalVisibilityService: ModalVisibilityService,
    ) {
        super(editModalService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.modalVisibilitySub = this.modalVisibilityService.closeEditDialogModalsRequestAnnounced$.subscribe(_ => {
            this.closeRPricesInfoModal();
        });
    }


    public isSelectedPriceTypeEqualOtherPrice(priceLevel: string): boolean {
        return this.editModalCustomPriceTableService.isSelectedPriceTypeEqualOtherPrice(priceLevel);
    }

    public priceNoteShouldBeVisible(priceType: string): boolean {
        return this.editModalCustomPriceTableService.priceNoteShouldBeVisible(priceType);

    }


    public getCurrentProductDistributorName(): string {
        const dName = this.editModalService.getCurrentProductDistributorName();
        return dName ? dName : '-';
    }

    public getCurrentSecondaryDistributorName(): string {
        const dName = this.editModalService.getCurrentSecondaryProductDistributorName();
        return dName ? dName : '-';
    }


    public isActivePriceApprovalMode() {
        return this.usePriceApprovalMode === MyPriceApprovalModeEnum.ACTIVE;
    }


    public closeRPricesInfoModal() {
        if (this.rPriceInfoModalDialogRef) {
            this.rPriceInfoModalDialogRef.close();
            this.rPriceInfoModalDialogRef = undefined;
        }
    }


    public ngOnDestroy(): void {
        if (this.modalVisibilitySub) {
            this.modalVisibilitySub.unsubscribe();
        }
    }


    public getUpgradesInfoIconText(): string {
        return 'Lorem ipsum';
    }
}

